<template>
    <DCard
        :title="__('settings.tenant_settings.form.fields.communication_provider')"
        :subtitle="__('settings.tenant_settings.form.fields.communication_provider_hint')"
        padding
        class="mb-3"
    >
        <DSelect
            id="communication_provider"
            v-model="form.communication_provider"
            :options="communicationProviders"
            :placeholder="__(`settings.tenant_settings.form.fields.communication_providers.${form.communication_provider}`)"
            @update:value="updateValue"
        />
    </DCard>
    <DCard
        v-if="isBrevoActive"
        :title="__(`settings.tenant_settings.form.fields.communication_providers.${form.communication_provider}`)"
        padding
    >
        <BrevoForm
            :brevo-settings="brevoSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
    <DFabs>
        <DFab
            v-if="isBrevoActive === false"
            id="btn-save"
            icon="content-save"
            :label="__('messages.save')"
            @click="submitData(form)"
        />
    </DFabs>
</template>

<script setup>
import BrevoForm from '~@/Components/Settings/CommunicationProvider/BrevoForm'
import { computed } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const props = defineProps({
    communicationProvider: {
        type: String,
        default: null
    },
    communicationProviders: {
        type: Object,
        default: () => { return {} }
    },
    brevoSettings: {
        type: Object,
        default: () => { return {} }
    },
    hubspotSettings: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const isBrevoActive = computed(() => {
    return form.communication_provider === 'brevo'
})

const form = useForm({
    communication_provider: props.communicationProvider ?? null
})

const submitData = (form) => {
    form.post(route('settings.communication-provider.store'))
}
const updateValue = (value) => {
    form.communication_provider = value
}
</script>
